import { Smile } from "lucide-react";
import type { LucideProps } from "lucide-react";
import { forwardRef } from "react";

export const SmileUpsideDown = forwardRef<SVGSVGElement, LucideProps>((props, ref) => (
  <Smile {...props} ref={ref} className={`${props.className ?? ""} rotate-180`} />
));
SmileUpsideDown.displayName = "SmileUpsideDown";

/** Hand-drawn curly arrow from the old app's empty states (points at the primary action).
 *  Strokes follow `currentColor` — set the color with a text-* utility on the wrapper. */
export function CurlyArrow({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width="289"
        height="390"
        viewBox="0 0 289 390"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <g clipPath="url(#curly-arrow-clip)">
          <path
            d="M158.087 247.036C152.436 238.389 138.203 216.934 129.521 209.514C120.839 202.094 114.865 199.622 106.313 197.382C97.7597 195.142 88.8106 194.867 80.1366 196.579C69.9531 199.26 60.6172 204.482 53.0042 211.757C45.3911 219.033 39.7503 228.122 36.6107 238.173C33.1248 249.32 31.8885 261.048 32.9736 272.676C34.0588 284.304 37.4436 295.6 42.9317 305.909C52.2996 323.578 69.8608 337.951 90.8929 333.773C121.55 327.679 140.329 291.057 151.33 265.338C151.645 264.597 157.776 247.783 158.087 247.036Z"
            stroke="currentColor"
            strokeWidth="3.39"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M165.846 42.8563C156.442 35.4284 147.037 28.0004 137.629 20.5723C136.111 19.3717 134.342 20.9011 134.105 22.4147C132.101 35.2174 130.099 48.0185 128.097 60.8182"
            stroke="currentColor"
            strokeWidth="3.39"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M174.765 381.72C178.656 344.837 176.255 306.279 166.544 270.485C164.154 262.362 161.73 254.357 158.072 246.721C167.336 215.958 170.314 183.855 168.06 151.806C165.724 117.64 158.751 83.9499 147.333 51.6631C143.962 41.7838 140.281 31.8702 136.062 22.2402"
            stroke="currentColor"
            strokeWidth="3.39"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="curly-arrow-clip">
            <rect
              width="183.498"
              height="336.196"
              fill="white"
              transform="translate(112.133 6.67773) rotate(18.8147)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
